@if (errors | async) {
  <mat-list>
    @for (err of errors | async; track err) {
      <mat-list-item>
        <mat-error>
          {{ err }}
        </mat-error>
      </mat-list-item>
    }
  </mat-list>
}
